import { use_slice_workspace, use_slice_workspace_billing } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { TABLE__empty } from '@/pages/_base/table/TABLE__empty';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { useTranslation } from 'react-i18next';
import { USListCreditsHistoryItem } from './USListCreditsHistoryItem';

export function USListCreditsHistory() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { workspace_current } = use_slice_workspace(['workspace_current']);
  const { credit_transactions_map } = use_slice_workspace_billing(['credit_transactions_map']);

  function render_items(credits: DTOWorkspaceCreditTransaction[]) {
    return credits.map((item, index) => <USListCreditsHistoryItem key={item._id} item={item} index={index} />);
  }

  function render_table() {
    const credits = Array.from(credit_transactions_map.values())
      .flatMap(innerMap => Array.from(innerMap.values()))
      .filter(item => item.workspace_id == workspace_current._id)
      .sort(DTO__database_entity.sort_by_created_at_newest_first);

    let out = <></>;

    if (credits.is_empty()) {
      out = <TABLE__empty />;
    } else {
      out = <div className="flex flex-col justify-start items-center h-[calc(100%-130px)] w-full overflow-auto">{render_items(credits)}</div>;
    }
    return out;
  }

  return (
    <div
      className={`${md('min-h-[350px] h-[350px]', ' h-full pt-2 pb-2 ')} 
      w-full my-3  flex flex-col justify-start items-start  border-b border-component-border  text-page-foreground`}
    >
      <div className="text-xl">{t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_transactions.title)}</div>
      <div
        className={`${md(' px-2 justify-between', 'gap-5 pr-5 pl-[76px] justify-start')} 
        border-b border-component-border  w-full min-h-[50px] flex flex-row items-center    mt-2`}
      >
        <span className={`${md('w-[45px] text-[10px]', 'w-[100px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_transactions.column.value)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_transactions.column.balance_before)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_transactions.column.balance_after)}
        </span>
        <span className={`${md('w-[70px] text-[10px]', 'w-[160px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_transactions.column.date)}
        </span>
        <span className={`${md('w-[70px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_transactions.column.type)}
        </span>
      </div>
      {render_table()}
    </div>
  );
}
